import { GridColDef } from "@mui/x-data-grid-pro";

export const GenerateLogContratoFinanceiroDetalhadoColumns = (): GridColDef[] => {

    const columns: GridColDef[] = [

        {
            field: "nomeUsuarioResponsavel",
            filterable: false,
            headerName: "Usuario Responsável",
            minWidth: 150,
            width: 150,
            sortable: false,
        },
        {
            field: "percentualJuros",
            filterable: false,
            headerName: "Percentual Juros",
            minWidth: 100,
            width: 100,
            align: 'center',
            sortable: false,
            renderCell: ({ value }) => (<div>{typeof value === 'number' && `${(value).toFixed(2)} %`}</div>),
        },
        {
            field: "dataAlteracao",
            filterable: false,
            headerName: "Data Alteração",
            minWidth: 120,
            width: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (!params) return "";
                return new Intl.DateTimeFormat("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                }).format(new Date(params));
            },
        },

        {
            field: "valorGlobal",
            filterable: false,
            headerName: "Valor Global",
            minWidth: 120,
            width: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (params == null) return "";
                return new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(params);
            },
        },
        {
            field: "valorTotal",
            filterable: false,
            headerName: "Valor Financiado com a construtora",
            minWidth: 120,
            width: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (params == null) return "";
                return new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(params);
            },
        },
        {
            field: "valorFinanciadoBanco",
            filterable: false,
            headerName: "Valor Financiado Banco",
            minWidth: 120,
            width: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (params == null) return "";
                return new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(params);
            },
        },
        {
            field: "motivo",
            filterable: false,
            headerName: "Motivo",
            flex: 1,
            minWidth: 150,
            width: 150,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex justify-center items-center">
                    {params.value}
                </div>
            )
        }

    ];

    return columns

}